import PageLayout from "../../../shared/ui/layouts/PageLayout/PageLayout";
import { TimeManagementFilterBar } from "./ui/TimeManagementFilterBar";
import { TimeManagementList } from "./ui/TimeManagementList";
import { CategoryActionMenu } from "./ui/CategoryActionMenu";

export const ZeitmanagementPage = () => {
  return (
    <PageLayout
      pageTitle="Zeitmanagement"
      headerChildren={<CategoryActionMenu />}
    >
      <div className="flex w-full flex-col gap-4">
        <TimeManagementFilterBar />
        <TimeManagementList />
      </div>
    </PageLayout>
  );
};
